<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { fetchPrivacyPolicyStore, usePrivacyPolicyData } from '@/services/privacyPolicyService'

interface HeroSection {
  title: string
  description: string
}

interface ContentItem {
  title: string
  text: string
}

interface Fields {
  privacypolicyhero: HeroSection
  content_list: ContentItem[]
}

const fields = ref<Fields>()

onMounted(async () => {
  await fetchPrivacyPolicyStore()
  fields.value = usePrivacyPolicyData().value
})
</script>

<template>
  <div class="flex flex-col items-center w-full lg:py-10">
    <div class="justify-center w-full max-w-[1200px] px-[10px] pt-5">
      <h1 class="lg:h3-bold h5-bold text-center">
        {{ fields?.privacypolicyhero?.title }}
      </h1>
      <div
        class="w-full mt-5 butter-wysiwyg space-y-3"
        v-html="fields?.privacypolicyhero?.description"
      ></div>
    </div>
    <div
      :key="index"
      v-for="(item, index) in fields?.content_list"
      class="px-[10px] lg:px-0 py-5 lg:items-start items-center lg:block flex flex-col w-full max-w-[1200px]"
    >
      <h3 class="lg:h3-bold h5-bold">{{ item.title }}</h3>
      <div v-html="item.text" class="w-full mt-5 butter-wysiwyg space-y-3 privacy-bullets"></div>
    </div>
  </div>
</template>

<style>
.privacy-bullets ul li {
  margin-top: 10px;
}
</style>
